<template>
    <AdvancedImage :cldImg="path" />
  </template>
  
  <script setup>
import { useImage } from "@/store/cloudinary";
import { AdvancedImage } from "@cloudinary/vue";
import { defineProps } from 'vue';

  const props = defineProps({
    publicId: {
      required: true,
      type: String,
    },
    width: [Number, String],
  });
  
  const path = useImage(props.publicId, Number(props.width));
  </script>
  